// Regras de cor do selo de diário (lista de turmas da escola e do professor).
//  verde    → todos os diários fechados
//  azul     → só o período atual (ou futuros) em aberto
//  vermelho → está no último período e o 1º ainda está aberto
//  laranja  → algum período anterior ao atual ainda aberto
import { getIstQuarter, getIIndQuarter, getIIIrdQuarter, getIVthQuarter } from '../Api';

// Em qual período (1, 2, 3...) a data de hoje está, pelas datas de início cadastradas.
// Antes do 1º → 1. Entre períodos → o último que já começou. Ano encerrado → último.
export const periodoAtualPorData = (quarters, totalPeriodos) => {
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    let atual = 1;
    quarters.slice(0, totalPeriodos).forEach((q, idx) => {
        if (!q) return;
        const inicio = new Date(Number(q.startyear), Number(q.startmonth) - 1, Number(q.startday));
        if (!isNaN(inicio) && inicio <= hoje) atual = idx + 1;
    });
    return Math.min(atual, totalPeriodos);
};

export const corDoDiario = (numsAbertos, periodoAtual, totalPeriodos) => {
    if (numsAbertos.length === 0) return 'green';

    const atrasados = numsAbertos.filter(n => n < periodoAtual);
    if (atrasados.length === 0) return 'blue';

    if (periodoAtual >= totalPeriodos && atrasados.includes(1)) return 'red';

    return 'orange';
};

// "1º", "2º", "3º" → "1º, 2º e 3º"
export const juntarPeriodos = (nums) =>
    nums.length <= 1 ? (nums[0] || '') : `${nums.slice(0, -1).join(', ')} e ${nums[nums.length - 1]}`;

/**
 * Calcula o status do diário de uma turma.
 * @param dailyStatus   class.dailyStatus  ({ "1º BIMESTRE": { regentTeacher, physicalEducationTeacher } ... })
 * @param regime        'TRIMESTRAL' | 'BIMESTRAL'
 * @param periodoAtual  número do período atual
 * @param chaves        opcional: quais diários considerar (ex.: ['regentTeacher'])
 */
export const statusDiarioTurma = (dailyStatus = {}, regime, periodoAtual, chaves = null) => {
    const isTrimestral = String(regime || '').toUpperCase() === 'TRIMESTRAL';
    const totalPeriodos = isTrimestral ? 3 : 4;

    const periodosAbertos = Object.keys(dailyStatus || {})
        .filter(p => parseInt(p, 10) <= totalPeriodos)
        .filter(p => {
            const diario = dailyStatus[p] || {};
            const valores = chaves ? chaves.map(k => diario[k]) : Object.values(diario);
            return valores.some(st => st !== undefined && st !== 'fechado');
        })
        .sort((a, b) => parseInt(a, 10) - parseInt(b, 10));

    const nums = periodosAbertos.map(p => parseInt(p, 10)).filter(n => !isNaN(n));
    const status = corDoDiario(nums, periodoAtual, totalPeriodos);

    const nomeRegime = isTrimestral ? 'trimestre' : 'bimestre';
    const texto = nums.length
        ? `${juntarPeriodos(periodosAbertos.map(p => p.match(/\d+º/)?.[0] || p))} ${nomeRegime}${nums.length > 1 ? 's' : ''}`
        : '';

    return { status, aberto: nums.length > 0, texto, totalPeriodos };
};

// Busca regime + período atual do ano letivo da escola.
export const carregarPeriodoAtual = async (year, idSchool) => {
    const [q1, q2, q3, q4] = await Promise.all([
        getIstQuarter(year, idSchool),
        getIIndQuarter(year, idSchool),
        getIIIrdQuarter(year, idSchool),
        getIVthQuarter(year, idSchool),
    ].map(p => p.catch(() => null)));

    const primeiro = (r) => r?.data?.data?.find(x => x) || null;
    const i = primeiro(q1);
    const regime = (i?.assessmentRegime || '').toUpperCase();
    const total = regime === 'TRIMESTRAL' ? 3 : 4;

    return {
        regime,
        periodoAtual: periodoAtualPorData([i, primeiro(q2), primeiro(q3), primeiro(q4)], total),
    };
};
